import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { ALTERATIONS_LIST_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export default function useRejectAlteration () {
    const {
        mutate: rejectAlteration,
        isLoading: isRejectAlterationLoading,
        isSuccess: isRejectAlterationSuccess,
        error: rejectAlterationError
    } = useMutation({       
        mutationFn: (payload: {alterationId: string, rejectReason: string}) => FinanceApprovalService.rejectAlteration(payload.alterationId, payload.rejectReason).catch(async (err) => {
                    const responseBody = await err.response.json();
                    ToastService.error(responseBody.msg);
                    throw err;
                }),
        options: {
            skipInvalidation: true
        },
        onSuccess: (c) => {
            c.invalidateQueries({
                queryKey: [...ALTERATIONS_LIST_QUERY_KEY]
            });
        }
    });
    return {
        rejectAlteration,
        isRejectAlterationLoading,
        isRejectAlterationSuccess,
        rejectAlterationError
    };
}